import React from 'react';
import type { AnimationItem } from 'lottie-web';
import lottie from 'lottie-web/build/player/lottie_light';

interface LottiePlayerProps extends React.HTMLAttributes<HTMLDivElement> {
  animationData: object;
  loop?: boolean | number;
  autoplay?: boolean;
  onReady?: (instance: AnimationItem) => void;
  onDestroy?: () => void;
}

const LottiePlayer: React.FC<LottiePlayerProps> = ({
  animationData,
  loop = false,
  autoplay = false,
  className,
  style,
  onReady,
  onDestroy,
  ...rest
}) => {
  const containerRef = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    if (!containerRef.current) return;

    const instance = lottie.loadAnimation({
      container: containerRef.current,
      renderer: 'svg',
      loop,
      autoplay,
      animationData,
    });

    onReady?.(instance);

    return () => {
      onDestroy?.();
      instance.destroy();
    };
  }, [animationData, loop, autoplay, onReady, onDestroy]);

  return (
    <div
      ref={containerRef}
      className={className}
      style={style}
      {...rest}
    />
  );
};

export default LottiePlayer;
